/** A referential list of processing run kinds: no tenant, no parameter. */
class FetchWorkflowRunKinds {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchWorkflowRunKinds;
